module.exports = __webpack_public_path__ + "static/media/confirm.03548fb8.svg";